import React from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt } from "react-icons/fa";

const projects = [
  {
    id: 1,
    title: "The Graham",
    location: "Tse Addo, Accra",
    image: "/images/graham1.jpg",
  },
  {
    id: 2,
    title: "Smart Homes",
    location: "Tse Addo, Ghana",
    image: "/images/solosec1.jpg",
  },
  {
    id: 3,
    title: "Premium Homes",
    location: "Burma Hills, Accra",
    image: "/images/about.png",
  },
  {
    id: 4,
    title: "Elegant Condos",
    location: "Tse Addo, Accra",
    image: "/images/project4.jpg",
  },
  {
    id: 5,
    title: "Smart Homes",
    location: "Tse Addo, Accra",
    image: "/images/project5.jpg",
  },
  {
    id: 6,
    title: "Ultra-Modern Homes",
    location: "Tse Addo, Accra",
    image: "/images/project6.jpg",
  },
];

const Projects = () => {
  return (
    <section className="bg-white py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto text-center mb-12">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-gray-900"
        >
          Our <span className="text-blue-600">Projects</span>
        </motion.h2>
        <div className="w-24 h-1 bg-blue-600 mx-auto mt-3 rounded-full"></div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-gray-600 max-w-2xl mx-auto mt-5"
        >
          Discover some of our finest developments — combining modern architecture,
          prime locations, and luxury living standards.
        </motion.p>
      </div>

      {/* Projects Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project, index) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            className="relative group rounded-xl overflow-hidden shadow-lg cursor-pointer"
          >
            {/* Project Image */}
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-blue-600/40 opacity-0 group-hover:opacity-100 transition duration-500 flex flex-col justify-end p-5">
              <h3 className="text-white text-xl font-semibold">{project.title}</h3>
              <p className="text-gray-200 flex items-center gap-2 mt-1">
                <FaMapMarkerAlt className="text-white" /> {project.location}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* CTA Button */}
      <div className="flex justify-center mt-10">
        <motion.a
          href="/projects"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg shadow-lg transition"
        >
          View All Projects
        </motion.a>
      </div>
    </section>
  );
};

export default Projects;
